export default "__VITE_ASSET__DqJoQ3bt__"